import { PatchUserGlobalPreferencesMutation, PatchUserGlobalPreferencesInput } from './__generated__/sdk';
import { getNotificationsClient } from './client';

export async function patchUserGlobalPreferences(
  input: PatchUserGlobalPreferencesInput
): Promise<PatchUserGlobalPreferencesMutation> {
  const client = await getNotificationsClient();
  return client.PatchUserGlobalPreferences({ input });
}
